import { toMonitored } from '../../editor/services/monitor';
import { isMemberPageInstalled as isProfilePageInstalled } from '../../editor/services/page';
import {
  addProfileCardWidget,
  alignProfileCardLayout,
} from '../../editor/services/profile-card';
import type { PlatformContext } from '../../types';
import { addMemberSettingsPage, addProfilePageWidget } from './services/widget';

export const installMemberSettingsPage = ({
  editorSDK,
  flowAPI,
}: Pick<PlatformContext, 'editorSDK' | 'flowAPI'>) => {
  return toMonitored('ma-split.install.add-profile-page-bob-widget', () => {
    return addMemberSettingsPage({
      editorSDK,
      flowAPI,
    });
  });
};

export const installProfilePage = async ({
  editorSDK,
  flowAPI,
}: Pick<PlatformContext, 'editorSDK' | 'flowAPI'>) => {
  await toMonitored('ma-split.install.add-profile-page-bob-widget', () => {
    return addProfilePageWidget({
      editorSDK,
      flowAPI,
    });
  });

  await addProfileCardWidget(editorSDK);
  await alignProfileCardLayout(editorSDK);
};

export const installProfilePageIfMissing = async (
  context: Pick<PlatformContext, 'editorSDK' | 'flowAPI'>,
) => {
  if (await isProfilePageInstalled(context.editorSDK)) {
    return;
  }

  await installProfilePage(context);
};
